// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UserAvatar Component Styles */

.user-avatar-wrapper {
    position: relative;
    display: inline-block;
}

/* Avatar sizes */
.user-avatar-wrapper.small {
    width: 32px;
    height: 32px;
}

.user-avatar-wrapper.medium {
    width: 40px;
    height: 40px;
}

.user-avatar-wrapper.large {
    width: 60px;
    height: 60px;
}

/* Image avatar */
.user-avatar-image {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    display: block;
}

/* Initials avatar */
.user-avatar-initials {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 600;
    text-transform: uppercase;
    -webkit-user-select: none;
            user-select: none;
}

/* Font sizes for different avatar sizes */
.user-avatar-wrapper.small .user-avatar-initials {
    font-size: 12px;
}

.user-avatar-wrapper.medium .user-avatar-initials {
    font-size: 14px;
}

.user-avatar-wrapper.large .user-avatar-initials {
    font-size: 20px;
}

/* Status indicator */
.user-avatar-wrapper .profile-status {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid white;
}

.user-avatar-wrapper.small .profile-status {
    width: 8px;
    height: 8px;
    border-width: 1.5px;
}

.user-avatar-wrapper.large .profile-status {
    width: 16px;
    height: 16px;
    border-width: 3px;
}

.profile-status.online {
    background-color: #43e97b;
}

.profile-status.offline,
.profile-status.ofline {
    background-color: #6c757d;
}

.profile-status.away {
    background-color: #f5576c;
}
`, "",{"version":3,"sources":["webpack://./src/components/Common/UserAvatar.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA,0CAA0C;AAC1C;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* UserAvatar Component Styles */\n\n.user-avatar-wrapper {\n    position: relative;\n    display: inline-block;\n}\n\n/* Avatar sizes */\n.user-avatar-wrapper.small {\n    width: 32px;\n    height: 32px;\n}\n\n.user-avatar-wrapper.medium {\n    width: 40px;\n    height: 40px;\n}\n\n.user-avatar-wrapper.large {\n    width: 60px;\n    height: 60px;\n}\n\n/* Image avatar */\n.user-avatar-image {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n    display: block;\n}\n\n/* Initials avatar */\n.user-avatar-initials {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-weight: 600;\n    text-transform: uppercase;\n    user-select: none;\n}\n\n/* Font sizes for different avatar sizes */\n.user-avatar-wrapper.small .user-avatar-initials {\n    font-size: 12px;\n}\n\n.user-avatar-wrapper.medium .user-avatar-initials {\n    font-size: 14px;\n}\n\n.user-avatar-wrapper.large .user-avatar-initials {\n    font-size: 20px;\n}\n\n/* Status indicator */\n.user-avatar-wrapper .profile-status {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    border: 2px solid white;\n}\n\n.user-avatar-wrapper.small .profile-status {\n    width: 8px;\n    height: 8px;\n    border-width: 1.5px;\n}\n\n.user-avatar-wrapper.large .profile-status {\n    width: 16px;\n    height: 16px;\n    border-width: 3px;\n}\n\n.profile-status.online {\n    background-color: #43e97b;\n}\n\n.profile-status.offline,\n.profile-status.ofline {\n    background-color: #6c757d;\n}\n\n.profile-status.away {\n    background-color: #f5576c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
